// extracted by mini-css-extract-plugin
export var quantityInput = "_nc-0";